import { useMemo } from 'react';

import config, { IS_ALLOWED_KATANA_DEPOSIT_WITHDRAW } from '#/config';
import { useSelector } from '#/reduxState/storeCore';

export function useDepositDisabledMessage(): string | false {
  const depositEnabled = useSelector(
    state => state.exchange.info.depositEnabled
  );
  const isRestrictedRegion = !!useSelector(
    state => state.region.restrictedRegion
  );
  const depositDisabledMessage = useMemo((): false | string => {
    if (isRestrictedRegion) {
      return 'Deposit not available in your region.';
    }
    if (config.env === 'sandbox' && !IS_ALLOWED_KATANA_DEPOSIT_WITHDRAW) {
      return 'Deposits are disabled in Sandbox.';
    }
    if (!depositEnabled) {
      return 'Deposits are temporarily disabled.';
    }
    return false;
  }, [depositEnabled, isRestrictedRegion]);
  return depositDisabledMessage;
}
